import { PartyStatus, PartyType } from '../components/Form/Party/PartyForm'
import { ShortUserListItemDto } from './userConfig'
import { AddressDto, Gender, PersonNameDto } from './contactConfig'
import { FileStatus, IReferenceDto } from './fileConfig'
import { AttributeEntityDto } from '../hooks/useAttributes'

export type PartyRecipientDto = {
    displayName: string
    email: string
}

export type ListItemDto = PartyRecipientDto & {
    id: string
    type: PartyType
    status: PartyStatus
    shortName: string
    displayName: string
    crmRelation?: boolean
    documentRootId?: string
}

export type PartyOverviewItemDto = ListItemDto & {
    salutation: string
    email: string
    phoneNumber: string
    identificationVerified?: boolean
    crmRelation: boolean
    accountManager?: ShortUserListItemDto
}

export type BasePartyDto = PartyOverviewItemDto &
    AttributeEntityDto & {
        shortName: string
        address?: AddressDto
        phoneLandline: string
        kycFiles: IReferenceDto[]
        description?: string
    }

export type LegalPersonDto = BasePartyDto & {
    name: string
    legalStructure: string
    poBoxAddress?: AddressDto
    financeTermInvoice?: number
    financeTermPayment?: number
    financeEmail?: string
    vatNumber?: string
    cocNumber?: string
    cocBranchNumber?: string
    reference?: string
    fileReferenceRequired?: boolean
}

export type NaturalPersonDto = BasePartyDto & {
    gender: Gender
    name: PersonNameDto
    attentionOf?: string
    phoneMobile?: string
    dateOfBirth: string
}

export type PartyCardFileDto = IReferenceDto & {
    status: FileStatus
}

/**
 * The read only party card (HAM-4353): the party itself, the parties it is linked to through the
 * files it participates in (a person's companies, a company's contact persons) and those files.
 */
export type PartyCardDto = {
    party: BasePartyDto
    relatedParties: ListItemDto[]
    files: PartyCardFileDto[]
}

export enum PartyAction {
    GetOverview = 'GET_PARTY_OVERVIEW',
    GetList = 'GET_PARTY_LIST',
    Reset = 'RESET_PARTIES',
}

export function isPartyOverviewItem(party: ListItemDto | PartyOverviewItemDto): party is PartyOverviewItemDto {
    return (<PartyOverviewItemDto>party).status !== undefined
}
